import axios from "axios";
import { Envs } from "../conf/envs";

const API_URL = `${Envs.API_BASE}/auth/`;
const TOKEN_KEY = "authorization-token-ea-ol";

export const getStoredAuthToken = () => {
	const token =
		sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
	return token || null;
};

export const setStoredAuthToken = (token) => {
	const serialized = JSON.stringify(token);
	sessionStorage.setItem(TOKEN_KEY, serialized);
	localStorage.removeItem(TOKEN_KEY);
};

export const clearStoredAuthToken = () => {
	sessionStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(TOKEN_KEY);
};

class AuthService {
	login(email, password) {
		return axios
			.post(API_URL + "login", {
				email,
				password,
			})
			.then((response) => {
				if (response.data.access_token) {
					setStoredAuthToken(response.data.access_token);
					this.updateAuthHeader();
				}

				return response.data;
			});
	}

	logout() {
		clearStoredAuthToken();
		delete axios.defaults.headers.common["Authorization"];
	}

	updateAuthHeader() {
		const token = getStoredAuthToken();
		if (token) {
			const parsedToken = token.startsWith('"') ? JSON.parse(token) : token;
			axios.defaults.headers.common["Authorization"] = `Bearer ${parsedToken}`;
		} else {
			delete axios.defaults.headers.common["Authorization"];
		}
	}

	register(username, email, password) {
		return axios.post(API_URL + "signup", {
			username,
			email,
			password,
		});
	}
	
	resetPassword(currentPassword, newPassword) {
		this.updateAuthHeader(); // Ensure header is up to date
		return axios.post(API_URL + "change-password", {
			currentPassword,
			newPassword,
		});
	}
	
	getCurrentUser() {
		const userStr = localStorage.getItem("user");
		if (userStr) return JSON.parse(userStr);
		return null;
	}
}

export default new AuthService();
